import { FC } from 'react';

import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import ConfirmableIconButton from 'components/ConfirmableIconButton';

type Props = {
  total?: number;
  selected?: number;
  loading?: boolean;
  onSelectAll?: () => void;
  onDelete?: () => void;
};

const GalleryToolbar: FC<Props> = props => {
  const {
    total = 0,
    selected = 0,
    loading = false,
    onSelectAll,
    onDelete,
  } = props;

  const allSelected = selected > 0 && total === selected;

  return (
    <Paper sx={{ mb: 2 }}>
      <Toolbar sx={{ display: 'flex', flexDirection: 'row' }}>
        <Typography sx={{ flexGrow: 1 }}>
          <FormControlLabel
            label={`Pasirinkta: ${selected}`}
            control={
              <Checkbox
                color="primary"
                checked={allSelected}
                onChange={onSelectAll}
              />
            }
          />
        </Typography>

        {selected > 0 && (
          <ConfirmableIconButton color="error" onConfirm={onDelete}>
            <DeleteIcon />
          </ConfirmableIconButton>
        )}
      </Toolbar>

      <Box sx={{ width: '100%' }}>
        {loading ? (
          <LinearProgress variant="indeterminate" />
        ) : (
          <Box sx={{ height: '5px' }} />
        )}
      </Box>
    </Paper>
  );
};

export default GalleryToolbar;
